import type { IntegrationSuggestion } from '@/features/integrations/integrations.types';
import { getBrandTileIcon } from '@/integrations/brand-tile-icons';
import { cn } from '@/lib/utils';

import { SuggestionIcon } from './suggestion-icon';

import type { ReactNode } from 'react';

export const SuggestionTile = ({
  suggestion,
  className,
  children,
}: {
  suggestion: IntegrationSuggestion;
  className?: string;
  children?: ReactNode;
}) => {
  const BrandTile =
    getBrandTileIcon(suggestion.toolkit_slug) ??
    getBrandTileIcon(suggestion.display_name);
  return (
    <span className={cn('relative inline-flex shrink-0', className)}>
      <span
        className={cn(
          'absolute inset-0 flex items-center justify-center overflow-hidden rounded-[inherit]',
          !BrandTile && 'bg-background ring-1 ring-inset ring-border-strong'
        )}
      >
        {BrandTile ? (
          <BrandTile className="size-full" />
        ) : (
          <SuggestionIcon suggestion={suggestion} className="size-1/2" />
        )}
      </span>
      {children}
    </span>
  );
};
